import api from '../config/api';

export const listMembers = async (params) => {
  const res = await api.get('/admin/members', { params });
  return res.data;
};

export const getMemberProfile = async (id) => {
  const res = await api.get(`/admin/members/${id}`);
  return res.data;
};

export const deleteMember = async (id) => {
  const res = await api.delete(`/admin/members/${id}`);
  return res.data;
};

export const toggleVip = async (id, isVip) => {
  const res = await api.patch(`/admin/members/${id}/vip`, { isVip });
  return res.data;
};

export const revokeToken = async (tokenId) => {
  const res = await api.post(`/admin/tokens/${tokenId}/revoke`);
  return res.data;
};

export const getAnalytics = async (range = '30d') => {
  const res = await api.get('/admin/analytics', { params: { range } });
  return res.data;
};

export const listUsers = async (params) => {
  const res = await api.get('/admin/users', { params });
  return res.data;
};

export const createUser = async (payload) => {
  const res = await api.post('/admin/users', payload);
  return res.data;
};

export const updateUser = async (id, payload) => {
  const res = await api.put(`/admin/users/${id}`, payload);
  return res.data;
};

export const deactivateUser = async (id) => {
  const res = await api.delete(`/admin/users/${id}`);
  return res.data;
};
